import React from "react";
import { Button } from "@mui/material";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";

export const KenBurnsModeBanner = ({ onClose }) => {
  const t = useScrollytellTranslation();

  return (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      style={{
        position: "absolute",
        top: 16,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1250,
        backgroundColor: "#0F172A",
        color: "#FFFFFF",
        border: "2px solid #4484F1",
        borderRadius: 999,
        padding: "8px 18px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        gap: 12,
        pointerEvents: "auto",
      }}
      data-testid="kenburns-mode-banner"
    >
      <span
        style={{
          backgroundColor: "#4484F1",
          color: "#FFFFFF",
          padding: "2px 8px",
          borderRadius: "12px",
          fontSize: "11px",
          fontWeight: 700,
          letterSpacing: "0.5px",
        }}
      >
        {t("imageFocusZoomPicker.modeActiveBadge", "FOKUSPUNKT-MODUS AKTIV")}
      </span>
      <span style={{ fontSize: "13px", fontWeight: 500, color: "#E2E8F0" }}>
        {t(
          "imageFocusZoomPicker.bannerHelp",
          "Klikk eller dra i bildet for å velge fokus. Trykk Ferdig (eller Esc) for å redigere tekst igjen."
        )}
      </span>
      <Button
        size="small"
        variant="contained"
        onClick={onClose}
        data-testid="kenburns-banner-done-btn"
        sx={{
          backgroundColor: "#4484F1",
          color: "#FFFFFF",
          fontWeight: 600,
          fontSize: "12px",
          px: 2,
          py: 0.5,
          minWidth: "auto",
          textTransform: "none",
          "&:hover": { backgroundColor: "#3367D6" },
        }}
      >
        {t("imageFocusZoomPicker.done", "Ferdig")}
      </Button>
    </div>
  );
};
